import { SelectOption } from '@/components/Select';
import { buildToolOptions as trialBuildToolOptions } from '@/sections/trial/hero/pardot-data';

export const buildToolOptions: SelectOption[] = trialBuildToolOptions;

export const roleOptions: SelectOption[] = [
  { label: 'Productivity / Platform Engineer', value: 'Productivity / Platform Engineer' },
  { label: 'Build Engineer', value: 'Build Engineer' },
  { label: 'DevOps/CI Engineers', value: 'DevOps/CI Engineers' },
  { label: 'Senior/Lead Software Developer', value: 'Senior/Lead Software Developer' },
  { label: 'Application/Software Developer', value: 'Application/Software Developer' },
  { label: 'VP / Director of Engineering', value: 'VP / Director of Engineering' },
  { label: 'Other', value: 'other' },
];

export const interestOptions: SelectOption[] = [
  { label: 'Accelerate execution time for build and tests', value: 'Accelerate execution time for build and tests' },
  {
    label: 'Accelerate troubleshooting for build, test and CI failures',
    value: 'Accelerate troubleshooting for build, test and CI failures',
  },
  {
    label: 'Identify developer productivity bottlenecks with data analytics',
    value: 'Identify developer productivity bottlenecks with data analytics',
  },
  { label: 'Identify and eradicate flaky tests', value: 'Identify and eradicate flaky tests' },
  { label: 'Reduce cost for CI infrastructure', value: 'Reduce cost for CI infrastructure' },
  {
    label: 'Learn more about developer productivity engineering',
    value: 'Learn more about developer productivity engineering',
  },
  { label: 'Other', value: 'other' },
];
